<template>
    <b-modal id="activateuser"
             size="lg"
             ref="ActivateUserModal"
             no-close-on-esc
             no-close-on-backdrop>
        <template #modal-header class="mx-auto">
            <h5 class="modal-title modal-title-centered">Enable User</h5>
        </template>
        <template #default>
            <p class="modal-warning-text">
                {{activateUserMessage}}
            </p>
        </template>
        <template v-slot:modal-footer="{ ok, cancel }">
            <b-button class="um-btn" @click="activateUser()">{{activateButtonText}}</b-button>
            <b-button class="um-btn" @click="cancelChanges()">Cancel</b-button>
        </template>
    </b-modal>
    <CreateUser :isNewUser="isNewUser"
                :userEmailId="userEmailId"
                :accountName="accountName"
                :accountNumber="accountNumber"
                :accountId="accountId"></CreateUser>
    <ErrorMessage ref="errorMessageRef" :errorMessage="error"
                  callbackOnClose="cancelChanges"
                  @cancelChanges="cancelChanges"></ErrorMessage>
    <UserDisableError ref="userDisableErrorRef" :message="userDisableErrorMsg" :headerMessage="userDisableHeaderMessage"></UserDisableError>
    <loading v-model:active="isLoading" :can-cancel="true" :is-full-page="fullPage"></loading>
</template>
<script>
    import service from "../../services/api.services";
    import { Component as Loading } from "vue-loading-overlay";
    import CreateUser from "../CreateUser";
    import "vue-loading-overlay/dist/css/index.css";
    import { eventbus } from "../../main";
    import ErrorMessage from "./ErrorMessage";
    import UserDisableError from "./UserDisableError";

    export default {
        name: "ActivateUser",
        components: {
            Loading,
            ErrorMessage,
            CreateUser,
            UserDisableError
        },
        data() {
            return {
                isLoading: false,
                error: "",
                loggedInUserName: this.$store.getters.username,
                adfsUserDetails: null,
                fullPage: true,
                userDisableErrorMsg: "",
                userDisableHeaderMessage: "", 
            };
        },

        props: {
            accountNumber: String,
            accountName: String,
            accountId: String,
            userEmailId: String,
            isNewUser: Boolean,
            searchedUserDetail: {},
            activateUserMessage: String,
            activateButtonText: String
        },
        created() {
            var that = this;
            eventbus.on("setAdfsuserDetails", function (payLoad) {
                //console.log(payLoad)
                that.adfsUserDetails = payLoad;
            });
        },
        watch: {
            searchedUserDetail: function (newValue) {
                this.prepareActivateUserPopupData(newValue);
            }
        },
        mounted() {
            var that = this;
            eventbus.on("setAdfsuserDetails", function(data) {
                that.adfsUserDetails = data; 
                that.prepareActivateUserPopupData(that.searchedUserDetail);
                });
        },
        methods: {

            cancelChanges: function () {
                this.$bvModal.hide("activateuser");
                //this.$emit("OnCreateUserModalCancel");
            },

            activateUser: function () {
                this.activateUserStatus()
            },

            async activateUserStatus() {
                var that = this
                var userStatusObj = this.PrepareUserStatusObj()
                that.isLoading = true;
                await service.UpdateUserStatus(userStatusObj)
                    .then(response => {
                        if (response.data != null
                            && response.data.isStatusChanged == true
                            && that.searchedUserDetail.userCommunityType == "Partner User"
                            && !that.searchedUserDetail.isCustomerCommunityUser
                            && !that.searchedUserDetail.isValidPartenCommunityUser) {
                            if (that.$refs.userDisableErrorRef && that.$refs.userDisableErrorRef.$refs["UserDisableErrorModal"])
                                that.$refs.userDisableErrorRef.$refs["UserDisableErrorModal"].show();
                            else
                                that.$bvModal.show("UserDisableError");
                                return;
                        }
                        if (response.data!=null && response.data.isStatusChanged == true) {
                            that.isLoading = false;
                            that.$bvModal.hide("activateuser");
                            that.$bvModal.show("createuser");
                        }
                        else {
                            that.error = "error occured while Enabling user status."
                            if (that.$refs.errorMessageRef && that.$refs.errorMessageRef.$refs["ErrorMessageModel"])
                                that.$refs.errorMessageRef.$refs["ErrorMessageModel"].show();
                            else
                                that.$bvModal.show("errormessage");
                            that.isLoading = false;
                        }
                    })
                    .catch(error => {
                        that.isLoading = false;
                        console.log("api error:" + error);
                    });
            },

            PrepareUserStatusObj() {
                return {
                    UserName: this.searchedUserDetail.userName,
                    FirstName: this.searchedUserDetail.firstName,
                    MiddleInitial: this.searchedUserDetail.middleInitial,
                    LastName: this.searchedUserDetail.lastName,
                    Email: this.searchedUserDetail.email,
                    Title: this.searchedUserDetail.title,
                    Phone: this.searchedUserDetail.phone,
                    StreetAddress: this.searchedUserDetail.streetAddress,
                    City: this.searchedUserDetail.city,
                    State: this.searchedUserDetail.state,
                    PostalCode: this.searchedUserDetail.postalCode,
                    Country: this.searchedUserDetail.country,
                    SFAccountId: this.searchedUserDetail.sfAccountId,
                    SFContactId: this.searchedUserDetail.sfContactId,
                    AdfsGUID: this.searchedUserDetail.adfsGuid,
                    ProfileId: this.searchedUserDetail.profileId,
                    SfUserId: this.searchedUserDetail.sfUserId,
                    IsDisabled:this.adfsUserDetails.enabled,
                    LockStatus: this.adfsUserDetails.isLocked,
                    LoggedInUserName: this.loggedInUserName,
                    AccountId: this.accountId
                };
            },
            prepareActivateUserPopupData(searchedUserDetail) {
                // No existing user details (e.g. adding a brand-new user) — nothing to prepare.
                if (searchedUserDetail == null) return;
                var that = this;
                //Load Disable Partner community User Popup details
                if (searchedUserDetail.userCommunityType == "Partner User" && !searchedUserDetail.isCustomerCommunityUser &&
                    !searchedUserDetail.isValidPartenCommunityUser) {
                    that.userDisableErrorMsg = "Sorry, this action cannot be completed for this user: " +
                        "<br/> This user is a Partner contact not associated to a Partner account. " +
                        "<br/><br/> Please review the Knowledge Article: <br/>" +
                        "\"Receiving an Error When Adding Partner Contact to a Non-Partner Account in EUM\"";
                    that.userDisableHeaderMessage = "Error Message";
                }
            }
        }
    }
</script>
<style>
</style>
